module.exports = __webpack_public_path__ + "static/media/website_app_icon.4d84eddc.svg";